<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Dashboard Overview" subTitle="Jurnalku Admin" />

    <div class="row">
      <div class="col-lg-3 col-sm-6">
        <div class="card bg-white border-0 rounded-3 mb-4">
          <div class="card-body p-4 text-center">
            <div class="d-flex justify-content-center align-items-center bg-primary-transparent rounded-circle mx-auto mb-3" style="width: 60px; height: 60px;">
              <i class="material-symbols-outlined fs-24 text-primary">group</i>
            </div>
            <h3 class="fs-24 fw-bold mb-1">{{ stats.customers }}</h3>
            <span class="fs-14 text-secondary">Total Customers</span>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3 col-sm-6">
        <div class="card bg-white border-0 rounded-3 mb-4">
          <div class="card-body p-4 text-center">
            <div class="d-flex justify-content-center align-items-center bg-success-transparent rounded-circle mx-auto mb-3" style="width: 60px; height: 60px;">
              <i class="material-symbols-outlined fs-24 text-success">shopping_cart</i>
            </div>
            <h3 class="fs-24 fw-bold mb-1">{{ stats.orders }}</h3>
            <span class="fs-14 text-secondary">Total Orders</span>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3 col-sm-6">
        <div class="card bg-white border-0 rounded-3 mb-4">
          <div class="card-body p-4 text-center">
            <div class="d-flex justify-content-center align-items-center bg-warning-transparent rounded-circle mx-auto mb-3" style="width: 60px; height: 60px;">
              <i class="material-symbols-outlined fs-24 text-warning">build</i>
            </div>
            <h3 class="fs-24 fw-bold mb-1">{{ stats.services }}</h3>
            <span class="fs-14 text-secondary">Active Services</span>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3 col-sm-6">
        <div class="card bg-white border-0 rounded-3 mb-4">
          <div class="card-body p-4 text-center">
            <div class="d-flex justify-content-center align-items-center bg-danger-transparent rounded-circle mx-auto mb-3" style="width: 60px; height: 60px;">
              <i class="material-symbols-outlined fs-24 text-danger">payments</i>
            </div>
            <h3 class="fs-24 fw-bold mb-1">{{ stats.payments }}</h3>
            <span class="fs-14 text-secondary">Payments</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import PageTitle from '@/components/Common/PageTitle.vue';
import customerService from '@/services/customerService';
import orderService from '@/services/orderService';
import serviceService from '@/services/serviceService';
import paymentService from '@/services/paymentService';

export default defineComponent({
  name: 'DashboardPage',
  components: {
    PageTitle
  },
  setup() {
    const stats = ref({
      customers: 0,
      orders: 0,
      services: 0,
      payments: 0
    });

    onMounted(async () => {
      try {
        const [custRes, ordRes, servRes, payRes] = await Promise.all([
          customerService.getAll(),
          orderService.getAll(),
          serviceService.getAll(),
          paymentService.getAll()
        ]);
        
        stats.value.customers = custRes.data.length || 0;
        stats.value.orders = ordRes.data.length || 0;
        stats.value.services = servRes.data.length || 0;
        stats.value.payments = payRes.data.length || 0;
      } catch (error) {
        console.error("Error fetching dashboard stats", error);
      }
    });

    return {
      stats
    };
  }
});
</script>
